import { get, isNil } from 'lodash';
import { EnumDictionary } from 'src/app/shared/list-utils';
import { UserRoleModel } from '../user-role.model';
import { UserPermissionEnum } from './user-permission.enum';
import { UserRoleEnum } from './user-role.enum';

// default "Viewer" permissions
const viewerPermissions: UserPermissionEnum[] = [
    UserPermissionEnum.InviteUsers,
    UserPermissionEnum.ViewBookmarks,
    UserPermissionEnum.CopyUrl,
    UserPermissionEnum.SavePrivateBookmarks,
    UserPermissionEnum.PublishBookmarks
];

// default "Creator" permissions
const creatorPermissions: UserPermissionEnum[] = [
    ...viewerPermissions,
    UserPermissionEnum.EditBookmarks,
    UserPermissionEnum.RemoveTeamBookmarks,
    UserPermissionEnum.AddTeamBookmarks,
    UserPermissionEnum.EditTeamBookmarks
];

// default "Admin" permissions
const adminPermissions: UserPermissionEnum[] = [
    ...creatorPermissions,
    UserPermissionEnum.EditAllTeamBookmarks,
    UserPermissionEnum.CreateCollection,
    UserPermissionEnum.TransferContent,
    UserPermissionEnum.RemoveUser,
    UserPermissionEnum.AssignRole
];

const roleOrder: UserRoleEnum[] = [
    UserRoleEnum.Viewer,
    UserRoleEnum.Creator,
    UserRoleEnum.Admin
];

// default application role for users not in a team
export const defaultUserRole: UserRoleModel = {
    role_id: undefined,
    role_name: UserRoleEnum.Creator,
    role_display_name: '',
    role_description: '',
    permissions: [
        ...creatorPermissions
    ]
};

export const userRolePermissionsMap: EnumDictionary<UserRoleEnum, UserPermissionEnum[]> = {
    [UserRoleEnum.Viewer]: viewerPermissions,
    [UserRoleEnum.Creator]: creatorPermissions,
    [UserRoleEnum.Admin]: adminPermissions
};

export const userRolePermissionsDescriptionMap: EnumDictionary<UserRoleEnum, string> = {
    [UserRoleEnum.Viewer]: 'Can view team content and edit personal content',
    [UserRoleEnum.Creator]: 'Can edit and view team content',
    [UserRoleEnum.Admin]: 'Can manage team settings and edit all content'
};

export function createPermissionsFromRole(role: UserRoleEnum): UserPermissionEnum[] {
    return userRolePermissionsMap[role] || [];
}

export function normalizeUserRole(user_role: UserRoleModel): UserRoleModel {
    // NOTE: set user role with permissions, in the future permissions will be initialized server size
    const role_name: UserRoleEnum = get(user_role, 'role_name', defaultUserRole.role_name);
    const role_description: string = get(user_role, 'role_description', userRolePermissionsDescriptionMap[role_name]);
    const permissions: UserPermissionEnum[] = get(user_role, 'permissions', undefined);

    return {
        ...user_role,
        // normalize description
        role_description,
        // note: use service values, else computre permissions
        permissions: !isNil(permissions) ? permissions : createPermissionsFromRole(role_name)
    };
}

// compare role based on permission level (ascending)
export function compareRole(roleA: UserRoleEnum, roleB: UserRoleEnum): number {
    const aOrder = roleOrder.indexOf(roleA);
    const bOrder = roleOrder.indexOf(roleB);
    return aOrder - bOrder;
}
